import type { FC } from "react";
import { Modal } from "@mantine/core";
import {
  CarrierDeliveryInfo,
  CreatePickup,
  TranslationsAvailable,
} from "@jasper/shared";
import { OrderFilesManagement } from "/@/pages/orders/OrderFilesManagement";
import { CenteredModal } from "./CenteredModal";
import type { GetOrderByUniqueAttributeQuery } from "/@/generated/graphql";
import type { OrderPageState } from "./useOrderPage";

// OrderFilesManagement is typed with the codegen query type while the page uses
// the shared Order interface: both describe the same GraphQL payload.
type GqlOrderDetail =
  GetOrderByUniqueAttributeQuery["getOrderByUniqueAttribute"];

type OrderPageModalsProps = {
  state: OrderPageState;
};

// Modals shared by V1 and V2: files, pickup and carrier delivery details.
export const OrderPageModals: FC<OrderPageModalsProps> = ({ state }) => {
  const { order, modals, actions, pickupAvailabilities, connectedUserEmail } =
    state;

  if (!order) {
    return null;
  }
  const { deliveryCarrier, pickupCarrier } = order.user?.userGroup ?? {};

  return (
    <>
      <CenteredModal modal={modals.files}>
        <OrderFilesManagement
          order={order as unknown as GqlOrderDetail}
          closeModal={modals.files.close}
        />
      </CenteredModal>
      <Modal
        opened={modals.pickup.opened}
        onClose={modals.pickup.close}
        size="auto"
      >
        {pickupCarrier && (
          <CreatePickup
            onSubmit={actions.createPickup}
            orderId={order.id}
            orderReference={order.orderReference}
            lang={TranslationsAvailable.FR}
            pickupAvailabilities={pickupAvailabilities}
            pickupCarrier={pickupCarrier}
            connectedUserEmail={connectedUserEmail}
          />
        )}
      </Modal>
      <Modal
        opened={modals.carrierDelivery.opened}
        onClose={modals.carrierDelivery.close}
        size="auto"
      >
        {deliveryCarrier && (
          <CarrierDeliveryInfo
            orderId={order.id}
            deliveryCarrier={deliveryCarrier}
          />
        )}
      </Modal>
    </>
  );
};
